export default __webpack_public_path__ + "static/media/Jurado-4.05911bac.png";